// Host hash that prefixes a site's STS and API hosts (a<N>.auth.ikaun.com). Java String.hashCode
// of the host minus any "www.", so it must stay byte-for-byte stable.
export const stringToHash = (string) => {
    var i = string.indexOf('www.');
    if (i > -1) {
        string = string.substr(i + 4);
    }

    var hash = 0;
    if (string.length == 0) return hash;
    for (i = 0; i < string.length; i++) {
        var char = string.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    hash = Math.abs(hash).toString();
    return `a${hash}`;
};

// STS_SETTINGS' endpoint carries a {prefix} placeholder for the host hash. Every page that builds
// a UserManager must resolve it through here: oidc-client-ts rejects a callback whose authority
// differs from the one the sign-in started with.
export const resolveAuthority = (endpoint, host) =>
    endpoint.replace('{prefix}', stringToHash(host.toLowerCase()));

// oidc-client-ts parses a sign-in response with the parsing page's own response_mode, so every page
// that builds a UserManager uses this. Fragment keeps the authorization code (~3.5KB: encrypted, it
// carries the user's claims) out of the query string, where Windows App Service 404s anything over
// 2048 bytes and every hop would log it.
export const RESPONSE_MODE = "fragment";

// offline_access is what makes the STS issue the tab a refresh token.
export const SCOPE = "openid profile api offline_access";

// Silent renew settings for the app's UserManager (initial.js). oidc-client-ts retries a timed-out
// renew every 5s with no limit unless told otherwise, so a renew that can never finish (a frame
// that never gets our STS cookie) would hit the STS and the tenant's IdP for as long as the tab is
// open. After the cap it raises silentRenewError and the api interceptor's sign-in takes over once
// the token expires.
export const SILENT_RENEW = {
    automaticSilentRenew: true,
    maxSilentRenewTimeoutRetries: 3,
};

// UserManager settings for the pages that receive a sign-in response (callback.html,
// silentrefreshframe.html), where window.$tp.auth.endpoint is still the raw {{STS}} template.
export const callbackSettings = (endpoint, location, page) => ({
    authority: resolveAuthority(endpoint, location.host),
    client_id: location.host,
    redirect_uri: `${location.protocol}//${location.host}/${page}`,
    response_mode: RESPONSE_MODE,
});
